const CACHE_OBJ_NAME = "Requests";
const CACHE_VERSION = 1;
const CACHE_DB_NAME = "trypsplus-cache";

const openConnection = new Promise((resolve, reject) => {
  if (!window.indexedDB) {
    return reject("Browser doesn't support IndexedDB");
  }
  const request = indexedDB.open(CACHE_DB_NAME, CACHE_VERSION);
  request.onerror = (event) => {
    console.error(`Database error: ${event.target.errorCode}`);
    reject(event.target.errorCode);
  };
  request.onsuccess = (event) => resolve(event.target.result);
  request.onupgradeneeded = (event) => {
    const db = event.target.result;
    if (event.oldVersion < 1) {
      const store = db.createObjectStore(CACHE_OBJ_NAME, { keyPath: "key" });
      store.createIndex("date", "date");
      store.createIndex("fn", "fn");
      store.createIndex("uid", "uid");
    }
  };
});

const call = async (type, method, ...args) => {
  const db = await openConnection;
  const txn = db.transaction(CACHE_OBJ_NAME, type);
  const store = txn.objectStore(CACHE_OBJ_NAME);
  return new Promise((resolve, reject) => {
    const req = store[method](...args);
    txn.oncomplete = () => resolve(req);
    txn.onabort = txn.onerror = () => reject(txn.error);
  });
};

export const get = async (key) => (await call("readonly", "get", key)).result;

export const set = async (value) => await call("readwrite", "put", value);

export const clear = async () => await call("readwrite", "clear");

export const deleteBy = async (key, values) => {
  const db = await openConnection;
  const txn = db
    .transaction(CACHE_OBJ_NAME, "readwrite")
    .objectStore(CACHE_OBJ_NAME)
    .index(key)
    .openCursor();
  return new Promise((resolve, reject) => {
    txn.onsuccess = (event) => {
      const cursor = event.target.result;
      if (cursor) {
        values.indexOf(cursor.value[key]) > -1 && cursor.delete();
        cursor.continue();
      } else {
        resolve();
      }
    };
    txn.onabort = txn.onerror = () => reject(txn.error);
  });
};
